webpackJsonp([23],{

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VeranoPage_vue_vue_type_template_id_48fcef63_scoped_true___ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VeranoPage_vue_vue_type_script_lang_js___ = __webpack_require__(549);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__VeranoPage_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__VeranoPage_vue_vue_type_template_id_48fcef63_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__VeranoPage_vue_vue_type_template_id_48fcef63_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "48fcef63",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VeranoPage_vue_vue_type_script_lang_js___ = __webpack_require__(550);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_VeranoPage_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VeranoPage',
  mounted: function mounted() {
    this.getMateriasPendientes();
  },
  data: function data() {
    return {
      cargandoDatos: true,
      guardando: false,
      fueraDeTiempo: false,
      yaGuardado: false,
      materiasGuardadas: [],
      headers: [{
        text: '',
        value: 'checkbox',
        sortable: false
      }, {
        text: 'Materia',
        align: 'left',
        value: 'nombre'
      }, {
        text: 'Semestre',
        value: 'semestre'
      }, {
        text: 'Créditos',
        value: 'creditos'
      }, {
        text: 'Hrs. Teóricas',
        value: 'horasTeoricas'
      }, {
        text: 'Hrs. Prácticas',
        value: 'horasPracticas'
      }, {
        text: 'Estatus',
        value: 'estatus',
        sortable: false
      }],
      materias: [],
      seleccionadas: [],
      mensaje: '',
      mensajeTipo: 'success'
    };
  },
  methods: {
    getMateriasPendientes: function getMateriasPendientes() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('alumno/verano').then(function (response) {
        _this.fueraDeTiempo = response.data.fueraDeTiempo;
        _this.yaGuardado = response.data.yaGuardado;
        _this.materias = response.data.data;
        _this.materiasGuardadas = response.data.materiasGuardadas || [];
      }).finally(function () {
        _this.cargandoDatos = false;
      });
    },
    toggleMateria: function toggleMateria(materia) {
      var idx = this.seleccionadas.indexOf(materia);
      if (idx >= 0) {
        this.seleccionadas.splice(idx, 1);
      } else if (this.seleccionadas.length < 2) {
        this.seleccionadas.push(materia);
      }
    },
    estatusColor: function estatusColor(estatus) {
      if (estatus === 'Curso normal') return 'green';
      if (estatus === 'Repetición') return 'orange';
      return 'red';
    },
    guardar: function guardar() {
      var _this2 = this;
      if (this.seleccionadas.length < 1) return;
      this.guardando = true;
      this.mensaje = '';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('alumno/verano', {
        materias: this.seleccionadas.slice(0, 2)
      }).then(function (response) {
        _this2.mensajeTipo = 'success';
        _this2.mensaje = response.data.message;
        _this2.yaGuardado = true;
        _this2.materiasGuardadas = _this2.seleccionadas.map(function (code) {
          var found = _this2.materias.find(function (m) {
            return m.materia === code;
          });
          return {
            materia: code,
            nombre: found ? found.nombre : code
          };
        });
      }).catch(function () {
        _this2.mensajeTipo = 'error';
        _this2.mensaje = 'Ocurrió un error al guardar. Inténtalo de nuevo.';
      }).finally(function () {
        _this2.guardando = false;
      });
    }
  }
});

/***/ }),

/***/ 684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_VeranoPage_vue_vue_type_template_id_48fcef63_scoped_true___ = __webpack_require__(685);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_VeranoPage_vue_vue_type_template_id_48fcef63_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_VeranoPage_vue_vue_type_template_id_48fcef63_scoped_true___["b"]; });


/***/ }),

/***/ 685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',[_c('v-flex',{attrs:{"md12":""}},[_c('v-card',[_c('v-card-title',[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Pre-registro de Verano")])])]),_vm._v(" "),(_vm.fueraDeTiempo)?_c('v-card-text',[_c('v-alert',{attrs:{"type":"info","value":true}},[_vm._v("\n                        El período de registro para el curso de verano no está disponible en este momento.\n                    ")])],1):(_vm.yaGuardado)?_c('v-card-text',[_c('v-alert',{staticClass:"mb-3",attrs:{"type":"warning","value":true}},[_c('p',{staticClass:"mb-1"},[_vm._v("Seleccionar materias en esta sección no garantiza que el grupo se abra, ni que puedas cursar la materia en verano. El proceso de selección es únicamente para que el coordinador de carrera tenga una idea de la demanda de cada materia y así tomar decisiones sobre la apertura de grupos.")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("No realizar el pago o transferencia del curso de verano, hasta que tu coordinador de carrera te notifique la apertura oficial del mismo, de lo contrario cualquier pago realizado sin la autorización debida, NO habrá devolución ni compensación del pago correspondiente.")])]),_vm._v(" "),_c('v-alert',{staticClass:"mb-3",attrs:{"type":"success","value":true}},[_vm._v("\n                        Tu selección de materias para verano ha sido registrada. No es posible realizar cambios.\n                    ")]),_vm._v(" "),_c('p',{staticClass:"subheading"},[_vm._v("Materias registradas:")]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},_vm._l((_vm.materiasGuardadas),function(item){return _c('v-list-tile',{key:item.materia},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.nombre))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.materia))])],1)],1)}),1)],1):(!_vm.cargandoDatos && _vm.materias.length > 0)?_c('v-card-text',[_c('v-alert',{staticClass:"mb-3",attrs:{"type":"warning","value":true}},[_c('p',{staticClass:"mb-1"},[_vm._v("Seleccionar materias en esta sección no garantiza que el grupo se abra, ni que puedas cursar la materia en verano. El proceso de selección es únicamente para que el coordinador de carrera tenga una idea de la demanda de cada materia y así tomar decisiones sobre la apertura de grupos.")]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("No realizar el pago o transferencia del curso de verano, hasta que tu coordinador de carrera te notifique la apertura oficial del mismo, de lo contrario cualquier pago realizado sin la autorización debida, NO habrá devolución ni compensación del pago correspondiente.")])]),_vm._v(" "),(_vm.mensaje)?_c('v-alert',{staticClass:"mb-3",attrs:{"type":_vm.mensajeTipo,"dismissible":""},on:{"input":function($event){_vm.mensaje = ''}}},[_vm._v("\n                        "+_vm._s(_vm.mensaje)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.seleccionadas.length < 1,"loading":_vm.guardando},on:{"click":_vm.guardar}},[_vm._v("\n                            Guardar selección\n                        ")]),_vm._v(" "),_c('span',{staticClass:"ml-2 grey--text caption"},[_vm._v("\n                            Selecciona entre 1 y 2 materias\n                            ("+_vm._s(_vm.seleccionadas.length)+"/2 seleccionadas)\n                        ")])],1),_vm._v(" "),(_vm.$mq !== 'sm')?_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.materias,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{staticClass:"mt-0 pt-0",attrs:{"input-value":_vm.seleccionadas.includes(props.item.materia),"disabled":_vm.seleccionadas.length >= 2 && !_vm.seleccionadas.includes(props.item.materia),"hide-details":""},on:{"change":function($event){return _vm.toggleMateria(props.item.materia)}}})],1),_vm._v(" "),_c('td',[_c('div',[_vm._v(_vm._s(props.item.nombre))]),_vm._v(" "),_c('div',{staticClass:"caption grey--text"},[_vm._v(_vm._s(props.item.materia))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.semestre))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.creditos))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.horasTeoricas))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.horasPracticas))]),_vm._v(" "),_c('td',[_c('v-chip',{attrs:{"small":"","color":_vm.estatusColor(props.item.estatus),"text-color":"white"}},[_vm._v(_vm._s(props.item.estatus))])],1)]}}],null,false,884335490)}):(_vm.$mq === 'sm')?_c('v-data-iterator',{attrs:{"items":_vm.materias,"rows-per-page-items":[10],"content-tag":"v-layout","row":"","wrap":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-checkbox',{staticClass:"mt-0 pt-0",attrs:{"input-value":_vm.seleccionadas.includes(props.item.materia),"disabled":_vm.seleccionadas.length >= 2 && !_vm.seleccionadas.includes(props.item.materia),"hide-details":""},on:{"change":function($event){return _vm.toggleMateria(props.item.materia)}}}),_vm._v(" "),_c('div',[_c('h4',[_vm._v(_vm._s(props.item.nombre))]),_vm._v(" "),_c('div',{staticClass:"caption grey--text"},[_vm._v(_vm._s(props.item.materia))])])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Semestre:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.semestre))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Créditos:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.creditos))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Hrs. Teóricas:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.horasTeoricas))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Hrs. Prácticas:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.horasPracticas))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Estatus:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('v-chip',{attrs:{"small":"","color":_vm.estatusColor(props.item.estatus),"text-color":"white"}},[_vm._v(_vm._s(props.item.estatus))])],1)],1)],1)],1)],1)}}])}):_vm._e()],1):(!_vm.cargandoDatos)?_c('v-card-text',[_vm._v("\n                    Has acreditado todas las materias de tu plan de estudios.\n                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"280px","persistent":""},model:{value:(_vm.cargandoDatos),callback:function ($$v) {_vm.cargandoDatos=$$v},expression:"cargandoDatos"}},[_c('v-card',[_c('v-card-title',[_c('v-progress-circular',{attrs:{"size":50,"indeterminate":"","color":"primary"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v("Cargando materias")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []



/***/ })

});


// WEBPACK FOOTER //
// static/js/23.7f0c10b58f42f353e6b4.js